const MonthYearSelect = require('month-year-select').MonthYearSelect;

const deps = [require('ngreact').name];

module.exports = angular
  .module('bench.ui.monthYearSelect', deps)
  .directive('blMonthYearSelect', reactDirective => reactDirective(MonthYearSelect));
